import { render, staticRenderFns } from "./contentTitle.vue?vue&type=template&id=b9bd4f80&scoped=true&"
import script from "./contentTitle.vue?vue&type=script&lang=js&"
export * from "./contentTitle.vue?vue&type=script&lang=js&"
import style0 from "./contentTitle.vue?vue&type=style&index=0&id=b9bd4f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bd4f80",
  null
  
)

export default component.exports